var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "social"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.3613 10.1825C23.2188 10.2906 20.7031 11.6755 20.7031 14.755C20.7031 18.317 23.9042 19.5771 24 19.6083C23.9853 19.6851 23.4915 21.3341 22.3122 23.0142C21.2608 24.4928 20.1626 25.9689 18.4921 25.9689C16.8215 25.9689 16.3916 25.0208 14.4631 25.0208C12.5837 25.0208 11.9155 26.0001 10.3874 26.0001C8.85935 26.0001 7.79315 24.632 6.56725 22.9518C5.14728 20.9788 4 17.9137 4 15.0046C4 10.3386 7.10527 7.86391 10.1614 7.86391C11.7853 7.86391 13.1389 8.90561 14.1585 8.90561C15.1289 8.90561 16.6422 7.8015 18.4896 7.8015C19.1898 7.8015 21.7054 7.86391 23.3613 10.1825ZM17.6126 5.8261C18.3766 4.94042 18.9171 3.71149 18.9171 2.48257C18.9171 2.31215 18.9023 2.13934 18.8704 2.00012C17.6273 2.04573 16.1484 2.809 15.2566 3.8195C14.5564 4.59718 13.903 5.8261 13.903 7.07183C13.903 7.25905 13.9349 7.44627 13.9496 7.50627C14.0283 7.52067 14.156 7.53748 14.2837 7.53748C15.3991 7.53748 16.8019 6.8078 17.6126 5.8261Z",
    fill: "#8047FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.f5e7bfb4e96f75e8676f2b685c71594a.svg";
export { ForwardRef as ReactComponent };